// @flow

function CurrencyPipe(value: number, currency: string = 'USD') {
  return (value / 100).toLocaleString('en-US', {
    style: 'currency',
    currency,
    currencyDisplay: 'symbol',
  });
}

export default CurrencyPipe;
